import axios from "axios";

export const instance = axios.create({
  timeout: 10000
});

export const getStudentList = () => {
  return instance({
    method: "get",
    url: "/work/api/student"
  });
}

export const createStudent = data => {
  return instance({
    method: "post",
    url: `/work/api/student`,
    data
  });
};

export const updateStudent = (id, savedata) => {
  const data = {
    main: savedata.main,
    document: savedata.document
  };

  return instance({
    method: "put",
    url: `/work/api/student/${id}`,
    data
  });
};

export const importSchoolchildren = csv => {
  const data = {
    csv: csv,
    type : "import",
    encoding : "UTF-8"
  };

  return instance({
    method: "post",
    url: `/work/api/schoolchild-archive/rpc`,
    data
  });
};

export const deleteSchoolchild = id => {
  const data = {
    id: id,
    type: "delete"
  };
  return instance({
    method: "post",
    url: `/work/api/schoolchild-archive/rpc`,
    data
  });
};

export const getStudentProgramList = id => {
  return instance({
    method: "get",
    url: `/work/api/student/${id}/programs`
  });
}

export const addStudentFinalDoc = (id, groupId, fileData) => {
  const data = new FormData();
  data.set('attachment', fileData);

  return instance({
    method: "post",
    url: `/work/api/student/${id}/group/${groupId}/document/attachment`,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data,
  });
}

export const deleteStudentFinalDoc = (fileId) => {
  return instance({
    method: "delete",
    url: `/work/api/student/document/${fileId}`
  });
};

export default {
  getStudentList,
  getStudentProgramList,
  createStudent,
  updateStudent,
  importSchoolchildren,
  deleteSchoolchild,
  addStudentFinalDoc,
  deleteStudentFinalDoc
};
